module.exports = __webpack_public_path__ + "./images/3cd82b2895bcdde80a8c0355ab9a7a1a.webp";